import { connect } from 'react-redux'
import { compose, withHandlers } from 'recompose'
import { removeInactiveItemsFromCartAndContnue } from 'components/ShoppingQuote/BOTProductAndServicesQuote/components/actions'
import DiscontinuedItemInQuoteSubComponent from './DiscontinuedItemInQuoteSubComponent'

export default compose(
  connect(null, { removeInactiveItemsFromCartAndContnue }),
  withHandlers({
    continueHandler: ({ closeHandler, removeInactiveItemsFromCartAndContnue }) => () => {
      removeInactiveItemsFromCartAndContnue()
      closeHandler()
    }
  })
)(DiscontinuedItemInQuoteSubComponent)
